import React, { Component, Fragment } from 'react';
import {reqData} from './utils'
export default class ReqList extends Component {
  render(){
    var {selectedMot,data,selectedMotId,startIndex} = this.props;
    if(!selectedMot) return <div>Loading...</div>
    var reqs = [];
    var i = startIndex;
    var req = data.hitCondition[i++];

    while(req[0] != 0x371){
      reqs.push(req);
      req = data.hitCondition[i++];
    }
    //      //  <td><pre>{JSON.stringify(cancel,null,0)}</pre></td>
    function _reqElement(req,idx){
      if(reqData[req[0]]){
          return <span key={idx} className={"flag"}>{reqData[req[0]]} D:{req[1]}</span>
      }
      return <span key={idx} className={"flag"}>R:{req[0]} D:{req[1]}</span>
    }
    return <span>{reqs.map(_reqElement)}</span>
  }
}



// WEBPACK FOOTER //
// ./src/ReqList.js